import { column } from "@podtrac/common/grid";
import styles from "../link-report.module.scss";
import { Elide } from "./elide";

export const createdByColumn = () =>
    column.group({
        header: "Created By",
        columns: [
            column.accessor("createdByName", {
                id: "Created By",
                header: "",
                cell: CreatedByCell,
            }),
        ],
    });

function CreatedByCell({
    row: {
        original: { createdByName, createdByEmail },
    },
}) {
    return (
        <div className={styles.createdBy}>
            <Elide>{createdByName}</Elide>
            <small>
                <Elide>{createdByEmail}</Elide>
            </small>
        </div>
    );
}
